function f(e,t,r=!1){t.length>e.length&&([e,t]=[t,e]);let n=e.filter(function(i){return t.includes(i)});return r?[...new Set(n)]:n}export{f as intersect};
//# sourceMappingURL=arrays.mjs.map